import { RoomId, roomId } from "@common/domain";
import { JsonSchemaValidator } from "@common/json-schema-validator";

export class RoomStageLayoutFocusDeleteRequestDTO {
  private static validation = JsonSchemaValidator.compile(
    RoomStageLayoutFocusDeleteRequestDTO.validationSchema()
  );

  constructor(readonly data: RoomStageLayoutFocusDeleteRequest) {
    JsonSchemaValidator.assert(
      RoomStageLayoutFocusDeleteRequestDTO.validation,
      data
    );
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["roomId"],
      properties: {
        roomId
      }
    };
  }
}

interface RoomStageLayoutFocusDeleteRequest {
  roomId: RoomId;
}
